import { Action } from "./Action";
import { ActionCentre } from "./ActionCentre";
import { Actions, IAction, IHotelSearchResultJSONOfferDetails, IPopupSettings } from "./types";

export class HotelPopup {
    private actionService: ActionCentre;
    private sourceJSON: IHotelSearchResultJSONOfferDetails;
    private hotelPopupContainer: string = "data-hotel-popup-container";
    private popupContainer: HTMLElement = document.querySelector(`[${this.hotelPopupContainer}]`) as HTMLElement;

    constructor(actionsService: ActionCentre, sourceJSON: IHotelSearchResultJSONOfferDetails) {
        this.actionService = actionsService;
        this.sourceJSON = sourceJSON;

        this.runBindings();
    }

    public ActivatePopup() {
        const showAction = new Action(Actions.SHOW_OVERLAY, ["showOverlay", true]);
        this.actionService.Do(showAction);

        this.popupContainer.innerHTML = "";
        this.popupContainer.appendChild(this.createPopupHTML());
        this.popupContainer.style.display = "block";
    }

    public HidePopup() {
        const hideAction = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
        this.actionService.Do(hideAction);

        this.popupContainer.innerHTML = "";
        this.popupContainer.style.display = "none";
    }

    private runBindings() {
        const overlay: HTMLElement = document.querySelector("[data-overlay]") as HTMLElement;

        overlay.addEventListener("click", (e) => {
            this.HidePopup();
        });
    }

    private createPopupHTML(): HTMLElement {
        const json = this.sourceJSON;

        const offerPopup: HTMLElement = document.createElement("div");
        offerPopup.classList.add("offer__popup");
        offerPopup.addEventListener("click", (e) => { e.stopPropagation(); });

        const offerPopupClose: HTMLElement = document.createElement("div");
        offerPopupClose.classList.add("offer__popup__close");
        offerPopupClose.addEventListener("click", () => { this.HidePopup(); });

        const heading: HTMLElement = document.createElement("h3");
        heading.innerText = json.Headline;

        const image: HTMLElement = document.createElement("img");
        image.setAttribute("src", json.ImageURL);

        const saving: HTMLElement = document.createElement("em");
        saving.innerText = json.Saving;

        const price: HTMLElement = document.createElement("span");
        price.classList.add("price");
        price.classList.add(`value-${json.NoOfNights}`);
        price.innerHTML = `${json.NoOfNights} nights from <strong>£<span>${json.Price}</span></strong>pp (including flights)`;

        const description: HTMLElement = document.createElement("p");
        description.innerText = json.LongDescription;

        const validity: HTMLElement = document.createElement("p");
        validity.classList.add("valid");
        validity.innerText = `Valid from ${json.ValidFrom} until ${json.ValidTo}`;

        const footer: HTMLElement = document.createElement("h4");
        const footerDiv1: HTMLElement = document.createElement("div");
        footerDiv1.classList.add("phone");
        footerDiv1.innerHTML = `<div class="phone__number">0330·100·2220</div>`;

        const link: HTMLElement = document.createElement("a");
        link.setAttribute("href", json.URL);
        link.innerHTML = `See more <img src="/images/responsive2018/misc/icon_arrow.svg" width="12">`;

        footer.appendChild(footerDiv1);
        footer.appendChild(link);

        offerPopup.appendChild(offerPopupClose);
        offerPopup.appendChild(heading);
        offerPopup.appendChild(image);
        offerPopup.appendChild(saving);
        offerPopup.appendChild(price);
        offerPopup.appendChild(description);
        offerPopup.appendChild(validity);
        offerPopup.appendChild(footer);

        return offerPopup;
    }

}



// WEBPACK FOOTER //
// ./src/global/HotelPopup.ts